import mixpanel from 'mixpanel-browser';
import store from '../../redux/store';
import { getUniversityId, isUniGroup } from '../../helpers/Helpers';

const envCheck = process.env.APP_ENV === 'production';

if (envCheck) {
    mixpanel.init('532557fa817b09561760eebf7dc08d8a');
} else {
    mixpanel.init('5b9d42887c604ae2c4c4357910ea2ca6');
}

const getAccount = () => store.getState().account;
const getWidget = () => store.getState().widget;
const isAllowedToCall = () => {
    const groupsExceptions = [1];
    const universityId = +getUniversityId();
    const uniGroup = isUniGroup();
    const account = getAccount();
    const isTest = getWidget().isTestUniversity;
    return (
        (!account || (account && !account.isAmbassador)) &&
        !isTest &&
        (!uniGroup || (uniGroup && !groupsExceptions.includes(universityId)))
    );
};

const MixPanelService = {
    track: (name, props) => {
        if (isAllowedToCall()) {
            mixpanel.track(name, props);
        }
    },
};

export default MixPanelService;
